import styled from 'styled-components';

// reproduce Shrike Text styles in order to wrap text with sibling div
export const LabelAndTooltip = styled.div`
  font-size: ${props => props.theme.fontSizes[400]};
  font-family: ${props => props.theme.fontFamilies.main.regular};
  color: ${props =>
    props.color
      ? props.theme.colors.content[props.color]
      : props.theme.colors.content.primary};
  -webkit-font-smoothing: antialiased;
  letter-spacing: 0;
  line-height: 1.5;

  > div {
    display: inline-block;
    margin-left: 8px;
  }
`;
